module.exports = __webpack_public_path__ + "media/fonts/immaterial-5dbcbf313283d475c6fd90953da8c18b.woff";